import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";

import { Modal } from "@material-ui/core";
import { Box } from "@material-ui/core";

import { selectDishes } from "../../store/dishes/selectors";
import { selectRestaurantById } from "../../store/restaurants/selectors";
import { selectUser } from "../../store/user/selectors";

import Restaurant from "../../components/Restaurant";
import Dish from "../../components/Dish";
import ReviewForm from "./reviewForm";
import NewDishForm from "./newDishForm";

import { fetchRestaurantById } from "../../store/restaurants/actions";
import { fetchDishes } from "../../store/dishes/actions";

import "./style.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function RestaurantDetails() {
  const [open, setOpen] = useState(false);
  const [openDish, setOpenDish] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();

  const restaurant = useSelector(selectRestaurantById(id));
  const { token } = useSelector(selectUser);
  const dishes = useSelector(selectDishes);

  const apiId = restaurant && restaurant.id;

  const handleOpenDish = (id) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleOpen = (id) => {
    setSelectedId(id);
    setOpenDish(true);
  };

  const handleClose = () => setOpen(false);
  console.log("parent", selectedId);
  const handleCloseDish = () => setOpenDish(false);
  console.log("parent", selectedId);

  useEffect(() => {
    if (restaurant) dispatch(fetchDishes(apiId));
    if (!restaurant) dispatch(fetchRestaurantById(id));
  }, [dispatch, restaurant, id, apiId]);

  if (!restaurant) return <div>Loading...</div>;

  return (
    <body>
      <ul class="flex-container">
        <li className="restaurant">
          <Restaurant
            key={restaurant.id}
            id={restaurant.id}
            name={restaurant.name}
            rate={restaurant.rate}
            city={restaurant.city}
            imageUrl={restaurant.imageUrl}
            description={restaurant.description}
            address={restaurant.address}
            contact={restaurant.contact}
            website={restaurant.we}
          />
        </li>
        <li className="dishes">
          {token && (
            <button
              className="bua"
              onClick={() => handleOpenDish(restaurant.id)}
            >
              Add Dish
            </button>
          )}
          {dishes &&
            dishes.length > 0 &&
            dishes.map((dish) => {
              return (
                <Dish
                  key={dish.id}
                  id={dish.id}
                  name={dish.name}
                  description={dish.description}
                  overallRate={dish.overallRate}
                  benefitRate={dish.benefitRate}
                  sizeRate={dish.sizeRate}
                  tasteRate={dish.tasteRate}
                  presentationRate={dish.presentationRate}
                  overallReviewers={dish.overallReviewers}
                  benefitReviewers={dish.benefitReviewers}
                  sizeReviewers={dish.sizeReviewers}
                  tasteReviewers={dish.tasteReviewers}
                  presentationReviewers={dish.presentationReviewers}
                  token={token}
                  modal={() => handleOpen(dish.id)}
                />
              );
            })}
        </li>
      </ul>
      <Modal
        open={openDish}
        onClose={handleCloseDish}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ReviewForm selectedId={selectedId} />
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <NewDishForm selectedId={selectedId} />
        </Box>
      </Modal>
    </body>
  );
}
